<template>
    <section id="learning" class="mt-50 ">
        <div class="container">
            <ul id="learnArea">
                <li class="frame" v-for="item in learnData" :key="item.id">
                    <h2 class="title">
                        {{ item.title }} <img :src="item.titleImg" alt="" />
                    </h2>
                    <h3 class="mt-30">網路投保</h3>
                    <div v-html="item.text" class="textArea mb-30"></div>
                    <a :href="item.link1" class="btn" target="_blank">立即投保</a>
                    <a :href="item.link2" class="btn" target="_blank">了解更多</a>
                </li>
            </ul>
        </div>
    </section>
</template>
<script setup>
import { reactive, ref } from "vue";
const queryParams = new URLSearchParams(window.location.search);
const referrer_Activity_Code = ref (queryParams.get("referrerCode")||queryParams.get("ActivityCode")||"");
const learnData = reactive([
    {
        id:"1",
        title: "汽車險",
        titleImg: require("../assets/icon-car2.svg"),
        text: '<p class="text">強制險現省<span>330</span>元</p><p class="text">任意險享<span>82折</span>優惠</p><p class="text">&emsp;</p>',
        link1: `https://www.tmnewa.com.tw/ec/vehicle/car?InsCategory=Car&Project${referrer_Activity_Code.value ? `?&ActivityCode=${referrer_Activity_Code.value}` : ""}`,
        link2: `https://www.tmnewa.com.tw/ec/contents/vehicle/car.html${referrer_Activity_Code.value ? `?&ActivityCode=${referrer_Activity_Code.value}` : ""}`,
    },
    {
        id:"2",
        title: "機車險",
        titleImg: require("../assets/icon-motor.svg"),
        text: '<p class="text">強制險</p><p class="text">一年期現省<span>145</span>元  兩年期現省<span>215</span>元</p><p class="text">任意險享<span>82折</span>優惠</p>',
        link1: `https://www.tmnewa.com.tw/ec/vehicle/motor${referrer_Activity_Code.value ? `?&ActivityCode=${referrer_Activity_Code.value}` : ""}`,
        link2: `https://www.tmnewa.com.tw/ec/contents/vehicle/motor.html${referrer_Activity_Code.value ? `?&ActivityCode=${referrer_Activity_Code.value}` : ""}`,
    },
    {
        id:"3",
        title: "旅平險",
        titleImg: require("../assets/icon-travel.svg"),
        text: '<p class="text">旅遊出發一小時前都來得及!</p><p class="text">一天只要<span>61</span>元起！</p><p class="text">&emsp;</p>',
        link1: `https://www.tmnewa.com.tw/ec/travel/overseas/${referrer_Activity_Code.value ? `?referrerCode=${referrer_Activity_Code.value}` : ""}`,
        link2: `https://www.tmnewa.com.tw/ec/travel/overseas/${referrer_Activity_Code.value ? `?referrerCode=${referrer_Activity_Code.value}` : ""}`,
    },
    {
        id:"4",
        title: "住火險",
        titleImg: require("../assets/icon-house.svg"),
        text: '<p class="text">住火險享優惠<span>84折</span>起</p><p class="text">&emsp;</p><p class="text">&emsp;</p>',
        link1: `https://www.tmnewa.com.tw/ec/house/?InsCategory=House&Project${referrer_Activity_Code.value ? `&ActivityCode=${referrer_Activity_Code.value}` : ""}`,
        link2: `https://www.tmnewa.com.tw/ec/contents/house/house.html${referrer_Activity_Code.value ? `?ActivityCode=${referrer_Activity_Code.value}` : ""}`,
    },
    {
        id:"5",
        title: "傷害險",
        titleImg: require("../assets/icon-accident.svg"),
        text: '<p class="text">方便又快速！</p><p class="text">每日銅板保費，給您百萬保障</p><p class="text">&emsp;</p>',
        link1: `https://www.tmnewa.com.tw/ec/accident/${referrer_Activity_Code.value ? `?referrerCode=${referrer_Activity_Code.value}` : ""}`,
        link2: `https://www.tmnewa.com.tw/ec/accident/${referrer_Activity_Code.value ? `?referrerCode=${referrer_Activity_Code.value}` : ""}`,
    },
]);
</script>
<style lang="scss">
#learning {
    @media screen and (max-width: $pc) {
        background-size:20%;
        background-position: left 0 bottom 0;
    }
    @media screen and (max-width: $mobile-small) {
        padding-bottom:50px;
    }
    #learnArea{
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        justify-content: center;
    }
    .container {
        text-align: center;
        .frame {
            display: inline-block;
            width: calc((100% - 40px) / 3);
            background: $white;
            border-radius: $radius;
            overflow: hidden;
            vertical-align: top;
            min-height: 300px;
            border: 2px solid $black;
            box-sizing: border-box;
            padding:0 0 30px;
            @media screen and (max-width: $mobile-large) {
                width: calc((100% - 20px) / 2);
            }
            @media screen and (max-width: $mobile-small) {
                width:100%;
                min-height:inherit;
                padding:0 0 30px;
                margin:10px 0;

            }
            .textArea {
                color: #4f4f4f;
                font-weight: bold;
                @media screen and (max-width: $mobile-small) {
                    min-height:86px;
                }
            }
            h2 {
                color: #fefbe8;
                position: relative;
                background: $blue-700;
                padding: 10px 0;
                margin:0;
                font-size:20px;
                img {
                    position: absolute;
                    right: 5%;
                    bottom: 0;
                    width: 50px;
                    @media screen and (max-width: $pad) {
                        right:2%;
                    }
                }
            }
            h3 {
                margin-bottom: 5px;
                color: $blue-700;
                font-size: 20px;
            }
            .text {
                font-size: 16px;
                font-weight:400;
                span {
                    font-size: 20px;
                    color: $blue-700;
                    font-weight:700;
                }
            }
            .btn {
                width: 180px;
                padding: 8px 10px;
                margin: 5px auto 10px;
                display: block;
            }
        }
    }
}
</style>
